import ReportsapiClient from '@/services/ReportsapiClient'
export default {
    getTaxSummary(sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var report_by = typeof query.report_by != 'undefined' && query.report_by != '' ? '&report_by=' + query.report_by : ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + report_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/inventory/taxsummary/index/' + filter)
    },
    getTaxDetails(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var report_by = typeof query.report_by != 'undefined' && query.report_by != '' ? '&report_by=' + query.report_by : ''
        var id = typeof query.id != 'undefined' && query.id != '' ? '&id=' + query.id : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&report_by=' + report_by + id;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/inventory/taxsummary/details/' + page + '/' + count + filter)
    },
    getTaxDetailsExport(page, show, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var report_by = typeof query.report_by != 'undefined' && query.report_by != '' ? '&report_by=' + query.report_by : ''
        var id = typeof query.id != 'undefined' && query.id != '' ? '&id=' + query.id : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&report_by=' + report_by + id;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/inventory/taxsummary/export/' + filter)
    },
    /**
     *Refund History received reports api
     * @param {*} page 
     * @param {*} count 
     * @param {*} token 
     * @param {*} query 
     */
    getRefundHistory(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/inventory/refund/index/' + page + '/' + count + filter)
    },
    getRefundHistoryExport(page, count, sort, label, token, query) {
        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = ''
        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/inventory/refund/export/' + page + '/' + count + filter)
    },
    getPurchaseOrderExport(page, count, sort, label, token, query) {

        var query_string = Object.entries(query).length === 0 && query.constructor === Object ? 0 : 1;
        var filter = '?sort=' + sort + '&label=' + label;
        var warehouse = typeof query.warehouse != 'undefined' && query.warehouse != '' ? '&warehouse=' + query.warehouse : ''
        var status = typeof query.status != 'undefined' && query.status != '' ? '&status=' + query.status : ''
        var group_by = typeof query.group_by != 'undefined' && query.group_by != '' ? '&group_by=' + query.group_by : ''

        if (query_string == 1) {
            filter = '?sort=' + sort + '&label=' + label + '&from_date=' + query.from_date + '&to_date=' + query.to_date + '&custom=' + query.custom + '&select_columns=' + query.select_columns + warehouse + status + group_by;
        }
        ReportsapiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return ReportsapiClient.get('/inventory/purorder/export/' + page + '/' + count + filter)
    }
}